<template>
  <div>
    <!--Content_all-->
    <section class="content_all cont_int product_intern produc_c2">
      <Header></Header>
      <div class="wrapper_m">
        <section class="titulo">
          <h1>MARKETING</h1>
          <div class="tab_tittle right">
            <a href="marketing">
              <span>BTL/POP</span>
            </a>
            <a href="marketing-google" class="active">
              <span>Google</span>
            </a>
            <a href="marketing-facebook">
              <span>Facebook</span>
            </a>
            <a href="marketing-instagram">
              <span>Instagram</span>
            </a>
            <!--<a href="marketing-detail">Precio</a>-->
          </div>
        </section>
      </div>

      <!--Descripcion-->
      <section class="wrapper_m p_b_30">
        <ul class="detail_1">
          <li class="paddg block">
            <section class="flex">
              <div class="small-12 medium-6 large-7 columns">
                <img src="assets/images/productos/marketing/google/img1.jpg" />
              </div>
              <div class="small-12 medium-6 large-5 columns">
                <div class="txt">
                  <h2 class="morado">
                    La evolución del
                    <br />voz a voz
                  </h2>
                  <p>Escucha a tus clientes y utiliza sus opiniones a tu favor para que todos se enteren de tu increíble servicio y asombrosos productos.</p>
                </div>
              </div>
            </section>
          </li>
          <li class="paddg block">
            <section class="flex">
              <div class="small-12 medium-6 large-5 columns">
                <div class="txt txt_right">
                  <h2 class="morado">Hazte fácil de encontrar</h2>
                  <p>Optimiza tu información para que todos te encuentren por cualquier lugar, fácil y rápido.</p>
                </div>
              </div>
              <div class="small-12 medium-6 large-7 columns">
                <img src="assets/images/productos/marketing/google/img2.jpg" class="img_grand" />
              </div>
            </section>
          </li>
          <li class="paddg block">
            <section class="flex">
              <div class="small-12 medium-6 large-7 columns">
                <img src="assets/images/productos/marketing/google/img3.jpg" class="img_phone" />
              </div>
              <div class="small-12 medium-6 large-5 columns">
                <div class="txt">
                  <h2 class="morado">Sincroniza tu información con los buscadores</h2>
                  <p>Ten constancia en toda la red y mantón toda tu información actualizada y lista para tus clientes.</p>
                </div>
              </div>
            </section>
          </li>
          <li class="paddg block">
            <section class="flex">
              <div class="small-12 medium-6 large-5 columns">
                <div class="txt txt_right">
                  <h2 class="morado">Vista 360</h2>
                  <p>Lleva a tus clientes a conocer tu restaurante antes de que te visiten.</p>
                </div>
              </div>
              <div class="small-12 medium-6 large-7 columns">
                <img src="assets/images/productos/marketing/google/img4.jpg" class="img_grand" />
              </div>
            </section>
          </li>
        </ul>
      </section>
      <!--Fin Descripcion-->
      <Footer></Footer>
    </section>
    <!--Fin Content_all-->
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  components: {
    Header,
    Footer
  }
}
</script>
